import React, {Component} from 'react';
import {Link} from "react-router-dom";
import {Modal, ModalFooter, ModalHeader} from "reactstrap";
import { withTranslation } from 'react-i18next';


class BusinessUnitTabsComponent extends Component {
    constructor(props) {
        super(props);
        this.state = {
            modal: false,
            changesMade: this.props.changesMade,
            tabUrlClicked: null
        };

        this.toggle = this.toggle.bind(this);
        this.handleCancelTabChange = this.handleCancelTabChange.bind(this);
        this.handleContinueNotSaving = this.handleContinueNotSaving.bind(this);
    }

    componentDidUpdate(prevProps) {
        if (this.props.changesMade !== prevProps.changesMade) {
            this.setState({
                changesMade: this.props.changesMade
            });
        }
    }

    handleTabClick = (e) => {
        if (this.state.changesMade) {
            e.preventDefault();
            this.setState({
                modal: true,
                tabUrlClicked: e.target.getAttribute('href')
            });
        }
    }

    toggle() {
        this.setState({
            modal: !this.state.modal
        });
    }

    getModalClassName() {
        if(this.props.className)
            return this.props.className
        else
            return "modal-body"
    }

    handleCancelTabChange() {
        this.toggle()
    }

    handleContinueNotSaving() {
        this.props.goToTabUrl(this.state.tabUrlClicked);
    }

    render() {
        const { t } = this.props;
        return (
            <div className="filters">
                <ul className={'tabs ' + this.props.activeTab}>
                    <li>
                        <Link onClick={this.handleTabClick} className="tab-button" to={`/business-unit/${this.props.businessUnitId}/`}>
                            {t('business_unit_tabs.global_info')}
                        </Link>
                    </li>
                    <li>
                        <Link onClick={this.handleTabClick} id="ad_accounts_link" className="tab-button" to={`/business-unit/${this.props.businessUnitId}/accounts`}>
                            {t('business_unit_tabs.accounts')}
                        </Link>
                    </li>
                    <li>
                        <Link onClick={this.handleTabClick} className="tab-button" to={`/business-unit/${this.props.businessUnitId}/budget-history`}>
                            {t('business_unit_tabs.budget_history')}
                        </Link>
                    </li>
                    <li>
                        <Link onClick={this.handleTabClick} id="alerts_configuration_link" className="tab-button" to={`/business-unit/${this.props.businessUnitId}/alerts-configuration`}>
                            {t('business_unit_tabs.alerts_configuration')}
                        </Link>
                    </li>
                </ul>
                <Modal key="modal" isOpen={this.state.modal} toggle={this.toggle} className={this.getModalClassName()}>
                    <ModalHeader toggle={this.toggle}></ModalHeader>
                    <div className="modal-section">
                        <p>{t('business_unit_tabs.unsaved_changes_message')}</p>
                    </div>
                    <ModalFooter>
                        <div style={{
                            display: "flex",
                            justifyContent: "center",
                            width: "100%",
                            textAlign: "center",
                            clear:"both"
                        }}>
                            <div style={{margin:"0 10px"}}><input onClick={this.handleCancelTabChange} type="button" value={t('business_unit_tabs.go_back')} className="btn"/></div>
                            <div style={{margin:"0 10px"}}><input onClick={this.handleContinueNotSaving} type="button" value={t('business_unit_tabs.change_without_saving')} className="btn -alt"/></div>
                        </div>
                    </ModalFooter>
                </Modal>
            </div>
        )
    }
}

export const BusinessUnitTabs = withTranslation()(BusinessUnitTabsComponent);
